import api from './api';

const PermissionService = {
  async getTeamMemberPermissions(teamMemberId) {
    const response = await api.get(`/team-members/${teamMemberId}/permissions`);
    return response.data;
  },
  async getTeamMemberOwnPermissions() {
    const response = await api.get('/team-members/permissions/own');
    return response.data;
  }
};

export default PermissionService;

